import React from 'react';
import { AlertTriangle, ExternalLink } from 'lucide-react';

function formatCurrency(cents, currency = 'usd') {
    if (cents == null) return null;
    const dollars = cents / 100;
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: (currency || 'usd').toUpperCase(),
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(dollars);
}

function formatDate(dateStr) {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

export function AmountDueBanner({ latestInvoice, onPayNow, loading }) {
    // Only show if there's an open/payable invoice
    if (!latestInvoice || latestInvoice.status !== 'open') {
        return null;
    }

    const amount = formatCurrency(latestInvoice.amount_due_cents, latestInvoice.currency);
    const dueDate = formatDate(latestInvoice.due_at);

    return (
        <div style={styles.banner}>
            <div style={styles.content}>
                <AlertTriangle size={20} style={styles.icon} />
                <div style={styles.text}>
                    <div style={styles.amount}>{amount} due</div>
                    {dueDate && <div style={styles.dueDate}>Invoice due {dueDate}</div>}
                </div>
            </div>
            <button
                type="button"
                onClick={onPayNow}
                disabled={loading}
                style={styles.payButton}
            >
                Pay now
                <ExternalLink size={14} style={{ marginLeft: 6 }} />
            </button>
        </div>
    );
}

const styles = {
    banner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        padding: '16px 20px',
        background: 'rgba(245, 158, 11, 0.12)',
        border: '1px solid rgba(245, 158, 11, 0.25)',
        borderRadius: 8,
        marginBottom: 24,
    },
    content: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
    },
    icon: {
        color: '#FCD34D',
        flexShrink: 0,
    },
    text: {},
    amount: {
        fontSize: 16,
        fontWeight: 700,
        color: '#FCD34D',
    },
    dueDate: {
        fontSize: 13,
        color: '#FDE68A',
        marginTop: 2,
    },
    payButton: {
        display: 'inline-flex',
        alignItems: 'center',
        padding: '10px 16px',
        border: 'none',
        borderRadius: 6,
        background: '#F59E0B',
        color: '#000000',
        fontSize: 13,
        fontWeight: 700,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
    },
};
